import React from 'react';
import { Input } from './styled';
import { Input as InputType } from 'antd';
import { CommonInputProps } from './types';

/**
 * Простой стилизованный под наш дизайн Input.
 */
export const CommonInput = React.forwardRef<InputType, CommonInputProps>(
  ({ hasError, ...props }, ref) => <Input {...props} $hasError={hasError} ref={ref} />,
);

CommonInput.defaultProps = {
  allowClear: true,
};
